module.exports = __webpack_public_path__ + "img/sax-cerimonia.24936fed.jpg";